import { render } from "./Calendar.vue?vue&type=template&id=e6972270&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=e6972270&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e6972270"

export default script